import { render, staticRenderFns } from "./LiveFaceOne.vue?vue&type=template&id=7adeec2e&scoped=true&"
import script from "./LiveFaceOne.vue?vue&type=script&lang=js&"
export * from "./LiveFaceOne.vue?vue&type=script&lang=js&"
import style0 from "./LiveFaceOne.vue?vue&type=style&index=0&id=7adeec2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adeec2e",
  null
  
)

export default component.exports